import { DrawerFooter } from '@chakra-ui/react'
import { useTranslation } from 'react-i18next'

import { Box } from '@/components/ui/box'
import { Button } from '@/components/ui/button'
import useColorModeValue from '@/hooks/useColorModeValue'

const ResolutionDrawerFooter = ({
    onClose,
    onReplace,
    onKeep,
    shouldDisable,
}: {
    onClose: () => void
    onReplace: () => void
    onKeep: () => void
    shouldDisable: boolean
}) => {
    const { t } = useTranslation()
    const borderColor = useColorModeValue('gray.300', 'gray.700')

    return (
        <DrawerFooter borderTopWidth="1px" borderColor={borderColor} px="0" py="24px" display="block">
            <Box display="flex" justifyContent="flex-start">
                <Button variant="secondary" mr="18px" onClick={onClose}>
                    {t('tasksApprovals.drawer.buttons.cancel')}
                </Button>
                <Button
                    variant={shouldDisable ? 'primary' : 'reject'}
                    onClick={onReplace}
                    mr="16px"
                    fontSize="12px"
                    letterSpacing="1.5px"
                    textTransform="uppercase"
                    fontWeight="bold"
                    disabled={shouldDisable}
                >
                    {t('documents.resolutionDrawer.replace')}
                </Button>
                <Button
                    variant="primary"
                    onClick={onKeep}
                    letterSpacing="1.5px"
                    textTransform="uppercase"
                    fontWeight="bold"
                    disabled={shouldDisable}
                >
                    {t('documents.resolutionDrawer.keepBoth')}
                </Button>
            </Box>
        </DrawerFooter>
    )
}

export default ResolutionDrawerFooter
